// extracted by mini-css-extract-plugin
module.exports = {"button-style":"hollowButton_button-style__3Yv-s"};